module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	model: {
		forwardFilterChanges: false,
		resourceConnected: false,
	},

	events: {
		refresh: {
			type: 'click',
			selector: 'button[data-field-type="refresh"]',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				if(event.data.component.model.cooperationTable){
					event.data.component.model.cooperationTable.refreshData();
				}
			}
		}
	},

	methods: {
		onChange: function(isRelationChange, changeDone, fieldData){
			if(this.model.forwardFilterChanges && this.model.cooperationTable){
				var data = (this.model.dirtyFields || {}).data || {};
				var attributes = data.attributes || {};

				this.model.cooperationTable.onFilterChanged(
					attributes,
					isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
					isRelationChange ? (fieldData || {}).isLastRelationElement : false
				);
			}
		},
		submit: function(){}
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artCrm_entity_controller', function(controller){
					self.model.controller = controller;
				});
			}
			if(!self.model.cooperationTable && self.model.controller){
				self.model.controller.find('templates_artCrm_cooperation_table', function(table){
					self.model.cooperationTable = table;
				});
			}

			this.model.forwardFilterChanges = true;
			if(Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
				this.onChange();
			}
		}
	}
}